import React, { memo } from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { NavigationView } from '@jira/polaris__component-navigation-store/src/NavigationView.types.tsx';
import type { NavigationProject } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-jpd-nav-views/src/common/types.tsx';

type ActionButtonsProps = {
	navigationProject: NavigationProject;
	isProjectExpanded?: boolean;
	isProjectSelected?: boolean;
	onViewCreated: (view: NavigationView) => void;
	projectKey: string;
};

const LazyActionButtons = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "async-jira-navigation-apps-sidebar-nav4-sidebar-jpd-project-action-buttons" */ './index.tsx'
		).then(({ ActionButtons }) => ActionButtons),
	{
		includeInShellOnlySsrBundle: true,
		entryFsSsrLiftImportToModule: true,
	},
);

export const AsyncActionButtons: React.MemoExoticComponent<
	({
		navigationProject,
		isProjectExpanded,
		isProjectSelected,
		onViewCreated,
		projectKey,
	}: ActionButtonsProps) => React.JSX.Element
> = memo(
	({
		navigationProject,
		isProjectExpanded,
		isProjectSelected,
		onViewCreated,
		projectKey,
	}: ActionButtonsProps): React.JSX.Element => (
		<Placeholder name="nav4.sidebar.jpd-project-action-buttons">
			<LazyActionButtons
				navigationProject={navigationProject}
				isProjectExpanded={isProjectExpanded}
				isProjectSelected={isProjectSelected}
				onViewCreated={onViewCreated}
				projectKey={projectKey}
			/>
		</Placeholder>
	),
);
